module.exports = __webpack_public_path__ + "img/667-ed7c0b.png";